


















/**
 * External dependencies.
 */
import Component, { mixins } from 'vue-class-component'
/**
 * Internal dependencies.
 */
import { lazyInject } from '@/container'
import { TYPES } from '@/types'
import PhotosHelperMixin from '@/mixins/PhotosHelperMixin.vue'
import CyclingAds from '@/components/ui/CyclingAds.vue'
import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'
import UserAwards from '@/features/account/components/UserAwards.vue'
import UserGallery from '@/features/account/components/UserGallery.vue'

import { namespace as profileModule } from '@/store/profile'
import { namespace as authenticationModule } from '@/store/authentication'
import { UserData } from '@/store/authentication/interfaces/UserData'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {
    UserGallery,
    UserAwards,
    CyclingAds,
    LoadingSpinner
  }
})
export default class AccountProfile extends mixins(PhotosHelperMixin) {
  @Prop({ type: Object, required: true }) user: UserData
  @Prop(Boolean) autoload: boolean

  @lazyInject(TYPES.PhotoService)
  PhotoService: any

  @lazyInject(TYPES.UserService)
  UserService: any

  @lazyInject(TYPES.AdService)
  AdService: any

  photographer: object | Array<any> | any = {}
  adsForSlides: Array<any> = []
  meta: object | any = {}
  isMyProfile: boolean = false

  // computed properties
  @profileModule.Getter getProfileResults: any[]
  @profileModule.Getter getProfileFavorites: any[]
  @profileModule.Getter getResultsPhoto: string
  @profileModule.Getter getFavoritesPhoto: string

  @authenticationModule.Getter('isLoggedIn') isLoggedIn: boolean
  @authenticationModule.Getter getUserData: UserData

  created () {
    this.initData(this.user.id)
  }

  initData (userId: string) {
    this.reset()

    this.checkUserProfile()

    this.AdService.getAds({ location: 'profile' })
      .then((response: any) => {
        this.adsForSlides = response.data
      })
  }

  reset () {
    this.photographer = {}
    this.adsForSlides = []
    this.meta = {}
    this.isMyProfile = false
  }

  checkUserProfile (): void {
    if (this.isLoggedIn && this.user.id === this.getUserData.id) {
      this.isMyProfile = true

      return
    }

    this.isMyProfile = false
  }
}
